var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg002Rich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    style: {
      fill: "#4C4031"
    },
    d: "M32.835,18.169c-1.281,0-2.561-0.488-3.536-1.462c-0.39-0.391-0.39-1.024,0-1.414 c0.391-0.391,1.024-0.391,1.414,0c1.169,1.169,3.072,1.169,4.243,0c0.391-0.391,1.024-0.391,1.414,0 c0.391,0.39,0.391,1.023,0,1.414C35.396,17.681,34.116,18.169,32.835,18.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    style: {
      fill: "#C7B6A1"
    },
    d: "M39.034,39.689L39.034,39.689v-0.002v-3.999c0-0.847,2.617-2.337,6.232-2.885 c-1.26-2.712-3.16-5.166-5.656-7.08l-7.248-4.928c-0.379-0.29-0.784-0.557-1.206-0.795c-0.555-1.694-0.937-3.441-1.127-5.212 l-0.518-4.813c-0.046-0.426-0.046-0.855,0.005-1.28c0.064-0.539,0.135-1.312,0.165-1.4c0.063-0.182,0.149-0.388,0.233-0.59 c0.412-0.814,0.91-1.666,1.422-2.298c0.181-0.202,0.358-0.407,0.57-0.586c1.162-0.984,0.863-2.833-0.582-3.311 c-0.787-0.261-1.641-0.452-2.513-0.499c-0.083-0.005-0.167,0.002-0.25,0c-0.199-0.004-0.399-0.012-0.599,0.001 c-1.17,0.07-2.347,0.44-3.418,1.296c-0.359,0.288-0.787,0.431-1.216,0.435c-0.435-0.001-0.871-0.146-1.235-0.437 c-1.33-1.062-2.823-1.377-4.265-1.295c-0.872,0.047-1.725,0.238-2.512,0.499c-1.445,0.478-1.744,2.327-0.582,3.311 c0.122,0.103,0.252,0.236,0.383,0.373c0.041,0.041,0.081,0.082,0.12,0.123c0.171,0.187,0.345,0.397,0.521,0.621 c0.585,0.803,0.983,1.667,1.221,2.357c0.067,0.194,0.135,1.265,0.24,1.851c0.067,0.373,0.111,0.747,0.111,1.126v3.488 c0,2.037-0.255,4.063-0.737,6.038c-0.475,0.234-0.935,0.499-1.357,0.83l-7.048,5.135c-6.933,5.45-9.267,15.065-5.278,22.93 c1.663,3.281,3.968,6.097,6.675,6.28C9.835,54.991,10.086,55,10.341,55h19.694c-0.249-0.415-0.452-0.903-0.613-1.422 c0.104-0.004,0.208-0.003,0.311-0.011c6.523-0.44,10.737-4.497,9.302-10.265V39.689z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#D19D18"
    },
    d: "M48.034,41.592c-4.971,0-9-0.852-9-1.904v4.001c0.003,1.051,4.031,1.903,9,1.903 c4.969,0,8.997-0.852,9-1.903v-4.001C57.034,40.74,53.006,41.592,48.034,41.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    style: {
      fill: "#D19D18"
    },
    d: "M39.034,39.687L39.034,39.687L39.034,39.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    style: {
      fill: "#D19D18"
    },
    d: "M57.034,39.687L57.034,39.687L57.034,39.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#FCC62D"
    },
    d: "M57.034,35.688c0,1.052-4.029,1.904-9,1.904c-4.971,0-9-0.852-9-1.904 c0-1.051,4.029-3.096,9-3.096C53.006,32.592,57.034,34.637,57.034,35.688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    style: {
      fill: "#E4AF18"
    },
    d: "M48.034,37.592c-4.971,0-9-0.852-9-1.904v4.001c0.003,1.051,4.031,1.903,9,1.903 c4.969,0,8.997-0.852,9-1.903v-4.001C57.034,36.74,53.006,37.592,48.034,37.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    style: {
      fill: "#E4AF18"
    },
    d: "M39.034,35.687L39.034,35.687L39.034,35.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    style: {
      fill: "#E4AF18"
    },
    d: "M57.034,35.687L57.034,35.687L57.034,35.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    style: {
      fill: "#6B5B46"
    },
    d: "M30.034,17h-13c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1 C31.034,16.551,30.586,17,30.034,17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    style: {
      fill: "#6B5B46"
    },
    d: "M30.034,14h-13c-0.552,0-1-0.448-1-1s0.448-1,1-1h13c0.552,0,1,0.448,1,1 S30.586,14,30.034,14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#6B5B46"
    },
    d: "M30.034,11h-13c-0.552,0-1-0.448-1-1s0.448-1,1-1h13c0.552,0,1,0.448,1,1 S30.586,11,30.034,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#E4AF18"
    },
    d: "M48.034,53.592c-2.013,0-3.865-0.141-5.364-0.377 c-0.459,1.377-1.335,2.559-2.477,3.406c1.543,0.579,4.474,0.971,7.841,0.971c4.969,0,8.997-0.852,9-1.903v-4.001 C57.034,52.74,53.006,53.592,48.034,53.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      fill: "#E4AF18"
    },
    d: "M48.034,45.592c-4.971,0-9-0.852-9-1.904v0.994 c1.846,0.879,3.242,2.537,3.767,4.553c1.475,0.224,3.279,0.357,5.233,0.357c4.969,0,8.997-0.852,9-1.903v-4.001 C57.034,44.74,53.006,45.592,48.034,45.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "#D19D18"
    },
    d: "M48.034,49.592c-1.954,0-3.758-0.133-5.233-0.357 c0.147,0.565,0.233,1.154,0.233,1.764c0,0.775-0.131,1.519-0.364,2.216c1.499,0.236,3.351,0.377,5.364,0.377 c4.969,0,8.997-0.852,9-1.903v-4.001C57.034,48.74,53.006,49.592,48.034,49.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    style: {
      fill: "#FCC62D"
    },
    d: "M43.034,51c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7s3.134-7,7-7 C39.901,44,43.034,47.133,43.034,51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    style: {
      fill: "#DBCCBA"
    },
    d: "M8.034,41c-0.552,0-1-0.448-1-1c0-6.869,7.589-15,14-15c0.552,0,1,0.448,1,1 c0,0.552-0.448,1-1,1c-5.271,0-12,7.29-12,13C9.034,40.551,8.586,41,8.034,41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Rich);
export default __webpack_public_path__ + "static/media/002-rich.e44a6df35027e781d1c38a987b51c1e4.svg";
export { ForwardRef as ReactComponent };